module.exports = __webpack_public_path__ + "img/maps.b693dcc8.png";